import{a as t}from"./chunk-WIMGWYZL.js";function i(...e){return t(n,e)}var n=(e,r)=>e.length>=r;export{i as a};
